module.exports = __webpack_public_path__ + "img/icon-exercise-inactive.a8ef6991.png";